/* COLESICE theme: cart drawer behaviour.
   Decides what happens after something was added to the cart, following the theme setting "Cart type":
     drawer  -> the cart drawer opens
     popover -> a small "Added to cart" box opens under the header (it closes by itself)
     page    -> the shopper goes to the cart page
   Changes made inside the cart itself (quantity, remove, note, discount, recommendations) never reopen anything.
   The drawer contents are re-rendered by theme.js after every cart change (data-cart-section on .bag-drawer__inner). */

const Theme = window.Theme;
const DIALOG_ID = 'cart-drawer';
const AUTO_CLOSE_MS = 6000;

const getDialog = () => document.getElementById(DIALOG_ID);
const isPopover = (dialog) => !!dialog && dialog.classList.contains('cart-popover');
const startCount = Number(getDialog() && getDialog().dataset.itemCount);
let itemCount = Number.isNaN(startCount) ? null : startCount;
let closeTimer;

function armAutoClose(dialog) {
  clearTimeout(closeTimer);
  closeTimer = setTimeout(() => {
    if (!dialog.open) return;
    if (dialog.matches(':hover, :focus-within')) armAutoClose(dialog); // the shopper is using it: wait
    else Theme.closeDialog(dialog);
  }, AUTO_CLOSE_MS);
}

function reveal(addedKeys) {
  const type = Theme.config.cartType;
  if (type === 'page') {
    location.assign(Theme.config.routes.cart);
    return;
  }
  const dialog = getDialog();
  if (!dialog) return;
  if (isPopover(dialog)) {
    dialog.setAttribute('data-confirm', '');
    (addedKeys || []).forEach((key) => {
      dialog.querySelectorAll('[data-cart-line]').forEach((line) => { if (line.dataset.key === key) line.classList.add('is-added'); });
    });
    Theme.openDialog(dialog);
    document.body.classList.remove('is-locked'); // the small box does not lock the page
    armAutoClose(dialog);
  } else {
    Theme.openDialog(dialog);
  }
}

const keysFromResponse = (response) => {
  if (!response) return [];
  if (Array.isArray(response.items) && !response.token) return response.items.map((item) => item.key);
  return response.key ? [response.key] : [];
};

document.addEventListener('cart:change', (event) => {
  const { cart, source, response } = event.detail;
  if (cart) itemCount = cart.item_count;
  if (/^cart/.test(String(source))) return; // changed inside the cart UI
  reveal(keysFromResponse(response));
});

// An app added something with its own request: open the cart when the number of items went up.
document.addEventListener('cart:refreshed', (event) => {
  const cart = event.detail.cart;
  if (!cart) return;
  const increased = itemCount !== null && cart.item_count > itemCount;
  itemCount = cart.item_count;
  if (increased) reveal([]);
});

document.addEventListener('dialog:close', (event) => {
  const dialog = event.detail.dialog;
  if (dialog && dialog.id === DIALOG_ID) {
    clearTimeout(closeTimer);
    dialog.removeAttribute('data-confirm');
  }
});

// Small cart: close on Escape and on a click outside of it.
document.addEventListener('keydown', (event) => {
  const dialog = getDialog();
  if (event.key === 'Escape' && isPopover(dialog) && dialog.open) Theme.closeDialog(dialog);
});
document.addEventListener('click', (event) => {
  const dialog = getDialog();
  if (!isPopover(dialog) || !dialog.open) return;
  if (dialog.contains(event.target) || event.target.closest('[data-dialog-open="cart-drawer"]')) return;
  Theme.closeDialog(dialog);
});
